module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/map","commonjs2":"rxjs/add/operator/map","amd":"rxjs/add/operator/map"}
// module id = 12
// module chunks = 0 1